<template>
  <div>
    <div class="el-div-data">
      <div style="display: inline;width: 100%">
        <div class="bar">
          <!-- 这两个按钮用于转换页面布局形式，使得UL布局正确显示 -->
          <a class="list-icon" v-bind:class="{ 'active': layout == 'list'}" v-on:click="layout = 'list'"></a>
          <a class="grid-icon" v-bind:class="{ 'active': layout == 'grid'}" v-on:click="layout = 'grid'"></a>
        </div>
        <el-input  placeholder="关键字搜索(回车键)" @keydown.enter.native='searchName'
                   v-model="input" ref="mark"
                   class="el-input-search">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <div class="block" style="float: right;margin-right: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="page.pageSize"
            :current-page="page.pageNum"
            layout="prev, pager, next, jumper"
            :total="page.total">
          </el-pagination>
        </div>
      </div>
      <div>
        <vxe-table border="inner" style="height: 100%;font-size: 16px" :data="tableData"  align="center"
                   :row-style="{height:'20px'}"  :cell-style="{padding:'6px'}"  highlight-hover-row>
          <vxe-table-column  field="id" width="120" title="id"></vxe-table-column>
          <vxe-table-column field="name"  width="400" title="名称"></vxe-table-column>
          <vxe-table-column field="buildTime" width="240" title="更新时间"></vxe-table-column>
          <vxe-table-column  field="code" title="二维码(点击图片下载)">
            <template slot-scope="scope" prop="logo">
              <div>
                <el-link :underline="false"  @click="linkDownloadCode(scope.row.name,scope.row.code)">
                  <el-image :src="scope.row.code" class="vxe-image"  v-popover:popover/>
                </el-link>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="url" width="500" title="链接">
            <template slot-scope="scope" prop="url" >
              <el-link :underline="false"  @click="linkDownloadFile(scope.row.url)">{{scope.row.url}}</el-link>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainFirmware',
  data () {
    return {
      input: '',
      tableData: [{
        index: 0,
        id: 0,
        name: '',
        buildTime: '',
        url: '',
        code: ''
      }],
      page: {
        pageSize: 8, // 当前页个数
        pageNum: 1, // 当前页数
        total: 0 // 总个数
      },
      layout: 'list'
    }
  },
  mounted () {
    this.$refs['mark'].focus()
    this.getDataList()
    let vm = this
    this.bus.$on('busChangeFile', () => {
      vm.$refs['mark'].focus()
      vm.getDataList()
    })
  },
  methods: {
    getDataList () {
      this.$axios({
        url: this.$global.baseURL.concat('main/fileSearchByName?pageNum=')
          .concat(this.page.pageNum).concat('&pageSize=').concat(this.page.pageSize).concat('&name=').concat(this.input),
        method: 'get'
      }).then(successResponse => {
        // console.log(successResponse.data.data)
        if (successResponse.data.code === 200) {
          // 重新刷新数据
          let tmpItems = []
          let tmpName = ''
          let tmpBuildTime = ''
          let tmpUrl = ''
          let tmpCode = ''
          let list = successResponse.data.data.list
          for (let i = 0; i < list.length; i++) {
            tmpName = list[i].name
            tmpBuildTime = list[i].time
            tmpUrl = list[i].url
            tmpCode = this.$global.baseURL.concat(list[i].code)
            tmpItems.push({index: i,
              id: list[i].id,
              name: tmpName,
              buildTime: tmpBuildTime,
              url: tmpUrl,
              code: tmpCode})
          }
          this.page.pageSize = successResponse.data.data.pageSize
          this.page.pageNum = successResponse.data.data.pageNum
          this.page.total = successResponse.data.data.total
          this.tableData = tmpItems
          this.$forceUpdate()
        } else {
        }
      })
    },
    searchName () {
      this.page.pageNum = 1
      this.getDataList()
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.page.pageNum = val
      this.getDataList()
    },
    linkDownloadFile (url) {
      window.open(url, '_blank') // 新窗口打开外链接
    },
    linkDownloadCode (name, url) {
      let link = document.createElement('a')
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        link.href = URL.createObjectURL(blob)
        link.download = name.replaceAll('.', '_').concat('.png')
        document.body.appendChild(link)
        link.click()
      })
    }
  }
}
</script>

<style scoped>
.vxe-table-column{
  font-size: large;
}
.vxe-image-bigger{
  width: 200px;
  height: 200px;
  border: none;
}
.vxe-image{
  width: 60px;
  height: 60px;
  border: none;
}
.el-div-data{
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}
.el-row {
}
.el-col {
  border-radius: 4px;

}
.bg-purple-dark {
}
.bg-purple {
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  line-height: 30px;
}
.grid-span{
  font-size: 22px;
  color: crimson;
  padding: 20px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.div-data-head{
  width: 100%;
  height: 80px;
  display:inline;
  margin-bottom: 40px;
}
.el-input-search{
  width: 20%;
  min-width: 400px;
  margin-right: 40px;
  margin-bottom: 20px;
}
.el-link-size{
  font-size: 16px;
  top: 0;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/MainFile.vue